export const KINDRED_SUPPORT_EMAIL = "hello@kindredcommunity.app";
export const STEADY_HOUSE_SUPPORT_URL = "https://steadyhouse.co.uk/kindred/support/";
export const STEADY_HOUSE_WEBSITE_URL = "https://steadyhouse.co.uk";
export const STEADY_HOUSE_LEGAL_NAME = "Steady House Ltd";
export const STEADY_HOUSE_FOUNDER_NAME = "Hannah Graham";
export const KINDRED_PRIVACY_LEAD_TITLE = "Founder and privacy lead";
export const KINDRED_NZ_PRIVACY_OFFICER_TITLE = "Privacy Officer";
export const KINDRED_CANADA_PRIVACY_RESPONSIBLE_TITLE =
  "Person responsible for the protection of personal information";
export const STEADY_HOUSE_COMPANY_NUMBER = "17095183";
export const STEADY_HOUSE_REGISTERED_OFFICE =
  "Grosvenor House, 3 Chapel Street, Congleton, Cheshire, England, CW12 4AB";
export const STEADY_HOUSE_ICO_REGISTRATION_REFERENCE = "ZC121264";
export const ADULTING_PUBLIC_URL = "https://adultingapp.uk";
export const KINDRED_FEEDBACK_CHANNEL_NAME = "Kindred Feedback & Suggestions";
export const KINDRED_FEEDBACK_CHANNEL_PATH = "Community > Kindred Feedback & Suggestions";
export const KINDRED_FRENCH_TERMS_PATH = "/terms-fr";
export const KINDRED_FRENCH_PRIVACY_PATH = "/privacy-fr";
